/* eslint-disable prettier/prettier */
import React, { useMemo } from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';

import Tag from '..';

interface Props {
  time: { hours: number; minutes: number };
  className?: string;
  showIcon?: boolean;
}

const PreBookTag = ({ time, showIcon }: Props) => {
  const { t } = useStoreTranslation();

  const text = useMemo(
    () =>
      time.minutes < 0 || time.hours < 0
        ? t('tags.preBookTag.expired')
        : time.hours < 1
          ? t('tags.preBookTag.expirationMinutes', { count: time.minutes })
          : t('tags.preBookTag.expirationHours', { count: time.hours }),
    [time, t],
  );

  return (
    <Tag color="green" icon={'exclamation'}>
      {text}
    </Tag>
  );
};

export default PreBookTag;
